import React from 'react';

const EmptyQuery = () => {
    return (
        <div className="text-gray-400 italic text-center">Interrogazione risulta vuota</div>
    );
};

export default EmptyQuery;